import rivets from 'rivets'
import axios from 'axios'

class RecentlyViewed {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            loading: true,
            products: []
        }
    }

    async getProducts () {
        if (!localStorage.getItem('ESC_RECENTLY_VIEWED')) return
        this._data.loading = true
        let promiseArray = []
        let productHandles = JSON.parse(localStorage.getItem('ESC_RECENTLY_VIEWED'))
        for (let handle of productHandles) {
            promiseArray.push(new Promise(async (resolve, reject) => {
                try {
                    let request = await axios.get(`/products/${handle}?view=json`)
                    let product = request.data
                    product.url = `/products/${product.handle}`
                    product.hoverImage = product.images[1]
                    this._data.products.push(product)
                } catch (err) {
                }
            }))
        }
        this._data.loading = false
        await Promise.all(promiseArray)
        // console.log(this._data)
    }

    onInit () {
        this.rivetsBinders()
        this.getProducts()
        rivets.bind(this._elem, this._data)
        document.dispatchEvent(new Event('perfect-scroll-update'))
    }

    rivetsBinders () {
        rivets.binders['background'] = (el, value) => {
            el.style.setProperty('background-image', `url('${value}')`)
        }
    }
}

export default RecentlyViewed



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RecentlyViewed.js